<script setup lang="ts">
import { useState } from '../composables/useState';
import { useTranslations } from '../composables/useTranslations';

const t = useTranslations();
const { username } = useState();
</script>

<template>
  <!-- Speaking Encouragement Banner -->
  <div
    class="bg-gradient-to-r from-[#dd7631] to-[#e9985e] rounded-2xl shadow-sm p-5 text-white"
  >
    <h2 class="text-xl font-bold mb-2">
      {{ t.hello }} {{ username }}! {{ t.letsSpeak }}
    </h2>
    <p>
      {{ t.letsSpeakMessage }}
    </p>
  </div>
</template>
